import {
  EventStatusId,
  RugbyLeagueEventStatusId,
} from '@collector/sportsapi-client-legacy'

export default null

export const pitchOverlaySupportedStatuses: EventStatusId[] = [
  RugbyLeagueEventStatusId.FinishedRegularTime,
  RugbyLeagueEventStatusId.FinishedAfterExtratime,
  RugbyLeagueEventStatusId.FinishedAfterPenalties,
  RugbyLeagueEventStatusId.FinishedAwardedWin,
  RugbyLeagueEventStatusId.Abandoned,
  RugbyLeagueEventStatusId.Postponed,
  RugbyLeagueEventStatusId.Cancelled,
]
